import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import DashboardLayout from "../../DashboardLayout";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { fetchBlockedAdsData } from "../../../services/axios/apiManager";
import { handleErrors } from "../../../services/dataManager";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../Components/spinner";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function AdBlockingDetection() {
  const tableRef = useRef(null);
  const navigation = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [range, setRange] = useState("weekly");

  const getBlockedAdsData = async (rng = range) => {
    setFetching(true);
    const res = await fetchBlockedAdsData(rng);
    if (res?.data?.success && res?.data?.data) {
      setTableData(res.data.data);
    } else {
      handleErrors(res, navigation);
    }
    setFetching(false);
  };

  const handleChangeRange = async (str) => {
    setRange(str);
    await getBlockedAdsData(str);
  };

  const handleReset = () => setRange("");

  // Prepare chart data
  const chartData = {
    labels: tableData?.map((item) => `${item?.user_type}`),
    datasets: [
      {
        label: "Ads Blocked",
        data: tableData.map((item) => item.total_blocked),
        backgroundColor: "rgba(255, 99, 132, 0.7)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { labels: { color: "#ffffff" } },
    },
    scales: {
      x: { ticks: { color: "#ffffff" } },
      y: {
        beginAtZero: true,
        ticks: { color: "#ffffff" },
      },
    },
  };

  useEffect(() => {
    getBlockedAdsData(range);
  }, []);

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = tableData.map((item) => {
      return [item?.user_type, item?.total_blocked];
    });
    const config = {
      data: rows,
      columns: [{ title: "User Type" }, { title: "Blocked Ads" }],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };
    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [tableData]);

  return (
    <DashboardLayout>
      {/* Filter Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by User Type</h5>
          <div className="row align-items-center">
            <div className="col-md-3 mb-2">
              <Form.Select
                className="bg-dark text-light border-light"
                value={range}
                onChange={(e) => handleChangeRange(e.target.value)}
              >
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
                <option value="quarterly">Quarterly</option>
                <option value="yearly">Yearly</option>
              </Form.Select>
            </div>
            <div className="col-md-2 mb-2">
              {fetching ? (
                <LoadingSpinner size={"small"} />
              ) : (
                <Button className="btn btn-success" onClick={handleReset}>
                  Reset
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Ad Blocking Detection</h5>
          <p className="card-text">
            Track users who block ads to adjust monetization strategies.
          </p>
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-dark table-striped table-hover w-100"
            />
            {tableData.length === 0 && (
              <p className="text-center mt-3">No data available.</p>
            )}
          </div>
        </div>
      </div>

      {/* Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Ad Blocking by User Type & Activity</h6>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default AdBlockingDetection;
